module.exports = __webpack_public_path__ + "img/_add_note.549d1777.svg";